export default "__VITE_ASSET__BbvAdArM__"